import React, { useMemo, useState } from 'react'
const STATUS = ['-', '1', '0']

const sampleEmployees = []

const formatDateIso = (year, month, day) => {
    const mm = String(month).padStart(2, '0')
    const dd = String(day).padStart(2, '0')
    return `${year}-${mm}-${dd}`
}

export default function DynamicMonthAttendanceTable({ employees, byMonth= ()=>{} }) {
    const today = new Date()
    const defaultMonth = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}`
    const [month, setMonth] = useState(defaultMonth)
    const [attendance, setAttendance] = useState({})

    // compute days array when month changes
    const days = useMemo(() => {
        const [y, m] = month.split('-').map(Number)
        const daysInMonth = new Date(y, m, 0).getDate()
        const arr = []
        for (let d = 1; d <= daysInMonth; d++) arr.push({
            day: d,
            iso: formatDateIso(y, m, d)
        })
        byMonth(month)
        return arr
    }, [month])

    const toggleCell = (iso, empId) => {
        setAttendance(prev => {
            const prevRow = prev[iso] ? { ...prev[iso] } : {}
            const prevVal = prevRow[empId] ?? 0 // default to '-' index 0
            const nextVal = (prevVal + 1) % STATUS.length
            prevRow[empId] = nextVal
            return { ...prev, [iso]: prevRow }
        })
    }

    const getCellStatus = (iso, empId) => {
        return STATUS[(attendance[iso] && attendance[iso][empId]) ?? 0]
    }

    // quick summary counts per employee for selected month
    const summary = useMemo(() => {
        const map = {}
        employees.forEach(e => {
        map[e.id] = { present: 0, absent: 0, holiday: 0 }
        })
        days.forEach(d => {
        const row = attendance[d.iso] || {}
        employees.forEach(e => {
            const idx = row[e.id] ?? 0
            const val = STATUS[idx]
            if (val === '1') map[e.id].present++
            else if (val === '0') map[e.id].absent++
            else map[e.id].holiday++
        })
        })
        return map
    }, [attendance, days, employees])

   const exportCsv = () => {
  // Header row
  const header = ['Employee', ...days.map(d => d.day), 'Total'];

  // Totals for footer
  let footerTotals = {
    perDay: days.map(() => 0), // day-wise totals
    grandTotal: 0,
  };

  const rows = employees.map(e => {
    const row = [e.name];
    let total = 0;

    days.forEach((d, i) => {
      const val = parseInt(e.value[d.day] || 0, 10);
      total += val;
      row.push(val);

      // Add to footer day totals
      footerTotals.perDay[i] += val;
    });

    row.push(total);

    // Add to grand total
    footerTotals.grandTotal += total;

    return row;
  });

  // Footer row
  const footerRow = [
    'TOTAL',
    ...footerTotals.perDay,
    footerTotals.grandTotal
  ];

  // Build CSV
  const csvContent = [header, ...rows, footerRow]
    .map(r => r.join(','))
    .join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `tokens_${month}.csv`;
  a.click();
  URL.revokeObjectURL(url);
};


    console.log(employees)

    return (
        <div style={{ padding: 16, fontFamily: 'Inter, system-ui, -apple-system, sans-serif' }}>
            <h3 style={{ margin: 0, marginBottom: 8 }}>Monthly Tokens</h3>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 12 }}>
                <label style={{ fontSize: 14 }}>Select month</label>
                <input
                    type="month"
                    value={month}
                    onChange={(e) => setMonth(e.target.value)}
                    style={{ padding: '6px 8px', borderRadius: 6, border: '1px solid #ddd' }}
                />
                <button onClick={exportCsv} style={{ marginLeft: 'auto', padding: '6px 10px', borderRadius: 6, border: 'none', background: '#0ea5a4', color: 'white' }}>
                Export CSV
                </button>
            </div>

            <div style={{ overflowX: 'auto', border: '1px solid #eee', borderRadius: 8 }}>
                <table style={{ borderCollapse: 'collapse', minWidth: 700, width: '100%' }}>
                    <thead>
                        <tr style={{ background: '#fafafa' }}>
                            <th style={{ textAlign: 'left', padding: '8px 10px', borderRight: '1px solid #eee' }}>#</th>
                            <th style={{ textAlign: 'left', padding: '8px 10px', borderRight: '1px solid #eee' }}>Employee</th>
                            <th style={{ textAlign: 'left', padding: '8px 10px', borderRight: '1px solid #eee' }}>Code</th>
                            {days.map(d => (
                                <th key={d.iso} style={{ padding: '6px', minWidth: 34, textAlign: 'center', borderRight: '1px solid #eee' }}>{d.day}</th>
                            ))}
                            <th style={{ padding: '6px 10px', textAlign: 'center' }}>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {employees.map((emp, i) => (
                            <tr key={emp.id} style={{ borderTop: '1px solid #f0f0f0' }}>
                                <td style={{ padding: '8px 10px', fontWeight: 600, borderRight: '1px solid #eee' }}>{i+1}</td>
                                <td style={{ padding: '8px 10px', fontWeight: 600, borderRight: '1px solid #eee' }}>{emp.name}</td>
                                <td style={{ padding: '8px 10px', fontWeight: 600, borderRight: '1px solid #eee' }}>{emp.id}</td>
                                {days.map(d => {
                                    const val = emp.value[d.day] || 0;
                                    let cellClass = "";
                                    if (val === 1) cellClass = "bg-warning";
                                    else if (val === 2) cellClass = "bg-success";

                                    return (
                                        <td
                                            key={d.iso + '-' + emp.id}
                                            onClick={() => toggleCell(d.iso, emp.id)}
                                            style={{
                                                padding: 6,
                                                textAlign: "center",
                                                cursor: "pointer",
                                                userSelect: "none",
                                            }}
                                            className={cellClass}
                                        >
                                            {val}
                                        </td>
                                    );
                                })}
                                <td style={{ padding: '6px 10px', textAlign: 'center' }}>{emp?.total ?? 0}</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr style={{ background: '#f5f5f5', fontWeight: 600 }}>
                            <td colSpan="3" style={{ padding: '8px 10px', textAlign: 'left' }}>Total</td>
                            {days.map(d => {
                                const daySum = employees.reduce(
                                (acc, emp) => acc + (emp.value[d.day] || 0), 0 );
                                return (
                                    <td
                                        key={'total-' + d.iso}
                                        style={{ padding: 6, textAlign: 'center' }}
                                    >
                                        {daySum}
                                    </td>
                                );
                            })}
                            <td style={{ padding: '6px 10px', textAlign: 'center' }}>
                                {employees.reduce((acc, emp) => acc + (emp?.total ?? 0), 0)}
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    )
}
